import axios from "../axios";

export default class FinishActivityService {
  async getCitiesActives() {
    let res = await axios.get("City/actives");
    return res.data;
  }

  async getAvaliableCities(){
    let res = await axios.get("City/GetCodeCityToCompleteActivity");
    return res.data;
  }

  async getTypeOsActives() {
    let res = await axios.get("TypeOs/actives");
    return res.data;
  }

  async getAccreditedsActives() {
    let res = await axios.get("Accrediteds/actives");
    return res.data;
  }

  async saveFinishActivityOs(data) {
    let res = await axios.post("Attendance/finish-attendance-dynamic", data);
    return res.data;
  }

  async saveTechnicianPhoneNumberAndAccredite(data) {
    let res = await axios.post("Technician", data);
    return res.data;
  }

  async getLowType(typeOsId) {
    let res = await axios.get(`/TypeOs/getForTypeLow?name_lowtype=${typeOsId}`);
    return res.data;
  }

  async getCodeCityByName(nameCity) {
    let res = await axios.get("City/GetCodeCityByName?name_city=" + nameCity);
    return res.data;
  }

  async getCityByCodeCity(codeCity) {
    let res = await axios.get(
      "City/GetCityByCode?code_city_netsms=" + codeCity
    );
    return res.data;
  }
  async getOptionList() {
    let res = await axios.get("/Attendance/get-service-option?type_attendance=19");
    return res.data;
  }
}
